<script>
    import { onMount, onDestroy } from 'svelte';
    export let draggable = true;
    let element;
    let bottomRow;
    let container;

    function onDragStart(event) {
        const ghost = this.cloneNode(true);
        ghost.style.display = 'none';
        event.dataTransfer.setDragImage(ghost, 0, 0);
    }

    function onDrag(event) {
        if (event.clientY) {
            const height =
                container.offsetHeight - (event.clientY - container.offsetTop);
            bottomRow.style.height = height + 'px';
        }
    }

    onMount(() => {
        bottomRow = element.nextElementSibling;
        bottomRow.style.height = bottomRow.offsetHeight + 'px';
        container = bottomRow.parentElement;
    });
</script>

<style>
    .splitter {
        background-color: #454545;
        height: 3px;
        cursor: ns-resize;
    }
</style>

<div
    bind:this={element}
    {draggable}
    on:dragstart={onDragStart}
    on:drag={onDrag}
    class="splitter" />
